(() => {
  if (customElements.get('product-engagement-tabs')) return;

class ProductEngagementTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.tabs = Array.from(this.querySelectorAll('[data-product-engagement-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-product-engagement-panel]'));
    this.panelsContainer = this.querySelector('.product-engagement__panels');

    if (!this.tabs.length || !this.panels.length) return;

    this.dataset.initialized = 'true';
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.resetTouch = this.resetTouch.bind(this);

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event));
    });

    document.addEventListener('shopify:block:select', this.handleBlockSelect);
    this.panelsContainer?.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    this.panelsContainer?.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    this.panelsContainer?.addEventListener('touchcancel', this.resetTouch, { passive: true });
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    this.panelsContainer?.removeEventListener('touchstart', this.handleTouchStart);
    this.panelsContainer?.removeEventListener('touchend', this.handleTouchEnd);
    this.panelsContainer?.removeEventListener('touchcancel', this.resetTouch);
  }

  activateTab(activeTab, moveFocus = false) {
    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;

      if (isActive && moveFocus) tab.focus();
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.blockId !== activeTab.dataset.blockId;
    });
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    if (nextIndex === currentIndex) return;

    event.preventDefault();
    this.activateTab(this.tabs[nextIndex], true);
  }

  handleTouchStart(event) {
    if (!window.matchMedia('(max-width: 749px)').matches || event.touches.length !== 1) {
      this.resetTouch();
      return;
    }

    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
  }

  handleTouchEnd(event) {
    if (
      this.touchStartX === undefined ||
      this.touchStartY === undefined ||
      !window.matchMedia('(max-width: 749px)').matches ||
      !event.changedTouches.length
    ) {
      this.resetTouch();
      return;
    }

    const deltaX = event.changedTouches[0].clientX - this.touchStartX;
    const deltaY = event.changedTouches[0].clientY - this.touchStartY;
    const isHorizontalSwipe = Math.abs(deltaX) >= 50 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

    this.resetTouch();

    if (!isHorizontalSwipe) return;

    const activeIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    const nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;

    if (nextIndex < 0 || nextIndex >= this.tabs.length) return;

    this.activateTab(this.tabs[nextIndex]);
  }

  resetTouch() {
    this.touchStartX = undefined;
    this.touchStartY = undefined;
  }

  handleBlockSelect(event) {
    const selectedTab = this.tabs.find((tab) => tab.dataset.blockId === event.detail.blockId);

    if (selectedTab) this.activateTab(selectedTab);
  }
}

customElements.define('product-engagement-tabs', ProductEngagementTabs);
})();
